import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

// Dashboard thank-you page completeness banner (#12798). "Hide for this
// session" removes the banner at once and records the dismissal in the Rails
// session (ThankYouNudgeDismissalsController) so the next dashboard render
// skips it. The flag is scoped to this sign-in by design — there is no
// permanent opt-out — so a failed POST costs nothing but a banner that
// reappears on the next page load; the removal is never rolled back over it.
//
// `post` resolves with `ok: false` on a non-2xx (a 302 to sign-in once the
// session expired, a 422 CSRF rejection, a 500) and rejects only on a
// network-level failure, so both outcomes are checked — neither is silent.
export default class extends Controller {
  static values = { url: String };

  async dismiss() {
    this.element.remove();
    try {
      const response = await post(this.urlValue, { responseKind: "json" });
      if (!response.ok) {
        console.warn(
          `Thank-you page banner dismissal was refused by the server (HTTP ${response.statusCode})`,
        );
      }
    } catch (error) {
      console.warn("Thank-you page banner dismissal did not reach the server", error);
    }
  }
}
